var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"bg"},[(!_vm.isScreenshot)?_c('el-button',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("关闭")]):_c('el-button',{staticClass:"close",on:{"click":_vm.htmlToImage}},[_vm._v("确定")]),_c('div',{staticClass:"canvas-container"},[_c('div',{staticClass:"canvas",style:({
                ..._vm.getCanvasStyle(_vm.canvasStyleData),
                width: _vm.changeStyleWithScale(_vm.canvasStyleData.width) + 'px',
                height: _vm.changeStyleWithScale(_vm.canvasStyleData.height) + 'px',
            })},_vm._l((_vm.copyData),function(item,index){return _c('ComponentWrapper',{key:index,attrs:{"config":item}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }